import { render, staticRenderFns } from "./questionnaire-footer.vue?vue&type=template&id=129dd1b7"
import script from "./questionnaire-footer.vue?vue&type=script&lang=js"
export * from "./questionnaire-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports